import type { BufferForChangeId } from '../../types';

export const doBufferedChangesHaveAConflict = ({
	bufferForChangeId,
}: {
	bufferForChangeId: BufferForChangeId;
}): boolean => {
	const changes = Object.values(bufferForChangeId)
		.flatMap((fieldsChanges) => (fieldsChanges !== null ? Object.entries(fieldsChanges) : []))
		.flatMap(([fieldId, properties]) =>
			Object.keys(properties).map((property) => `${fieldId}_${property}`),
		);

	return changes.length !== new Set(changes).size;
};

export const findAppsWhichDidNotSendChangesBeforeTimeout = (bufferForChangeId: BufferForChangeId) =>
	Object.entries(bufferForChangeId)
		.filter(([_, fieldsChanges]) => fieldsChanges === null)
		.map(([appId]) => appId);
